var Vue = window.Vue;
var vm;
if (!Vue) {
    Vue = require('vue');
}
if ($('#bookings-reports').length > 0) {
    var vm = new Vue({
        el: '#bookings-reports',
        components: {
            'bookings-vs-quotes': require('./components/Web/BookingsVsQuotes'),
            'used-promo-codes': require('./components/Web/UsedPromoCodes'),
            bookings: require('./components/Wheels/Bookings'),
        },
    });
}
module.exports = vm;
